<div id="print-section1" class="a4-print">
  <div class="p-50">
    <form [formGroup]="CommissionPayment" style="border: 3px solid #000; padding: 5px;">
      <div class="row" style="border: 3px solid #000; padding: 3px; margin: 0;">
        <div class="col-3 image">
          <img style="margin-top: 5%" width="70%" src="../../../assets/img/brand/red.png" />
        </div>
        <div class="col-7" style="padding-top: 10px; text-align: center; padding-bottom: 5px">
          <span style="font-size: 26px; font-weight: bold">हिंदुस्थान प्रकाशन संस्था</span>
          <span style="font-size: 14px; margin-left: 05px">(Reg.No.-BOM-3/1961[GBBSD])</span>
          <hr style="margin: 5px 0;" />
          <div class="row" style="text-align: left">
            <div class="col-6" style="padding-top: 5px">
              <span style="font-size: 12px"><span style="font-weight: bold; font-size: 14px">प्रशासकीय कार्यालय :
                  <br></span>
                116, 117, 118, 119, पहिला मजला, <br> शिल्पीन सेंटर, 40, ग. द. आंबेकर मार्ग, <br> वडाळा , मुंबई -
                400031<br /></span>
              <span style="font-size: 14px"><span style="font-weight: bold; font-size: 14px">दूरध्वनी :</span>
                9967570531</span>
            </div>
            <div class="col-6" style="border-style: solid; border-width: 0px 0px 0px 3px; padding-top: 5px;">
              <span style="font-size: 12px"><span style="font-weight: bold; font-size: 14px">मुख्य कार्यालय :
                  <br></span>
                5/12, कामत औद्योगिक वसाहत, <br>
                396, स्वा. वीर सावरकर मार्ग, <br> प्रभादेवी, मुंबई 400025.<br /></span>
              <span style="font-size: 14px"><span style="font-weight: bold; font-size: 14px">दूरध्वनी :</span>
                24221440</span>
            </div>
          </div>
        </div>
        <div class="col-2"
          style="border-style: solid; border-width: 0px 0px 0px 3px; text-align: center; display: flex; align-items: center;">
          <span style="font-size: 24px">जाहिरात <br>&nbsp;&nbsp; कमिशन पत्र</span>
        </div>
      </div>

      <table border="1" cellspacing="0" cellpadding="3"
        style="width: 100%; border: 1px solid #000; border-collapse: collapse; font-size: 11px;">
        <thead>
          <tr>
            <th colspan="9" class="comm-head p-10" style="text-align: center; padding: 6px;">जाहिरात प्रतिनिधी कमिशन
            </th>
          </tr>
          <!-- Representative Details Section -->
          <tr>
            <td colspan="4" style="text-align: left; padding: 8px; border: 1px solid #000;">
              <div style="line-height: 1.4;" *ngIf="getmodaldata && getmodaldata.length > 0">
                <div style="font-size: 14px;font-weight: bold;">{{getmodaldata[0]?.rep_name}}</div>
                <div style="font-size: 12px;">{{getmodaldata[0]?.address}}</div>
                <div style="font-size: 12px;">{{getmodaldata[0]?.taluka}}-{{getmodaldata[0]?.pincode}}</div>
                <div style="font-size: 12px;">मोबाईल-{{getmodaldata[0]?.rep_mob_no}}</div>
              </div>
            </td>
            <td colspan="5" style="border: 1px solid #000; font-weight: bold; font-size: 14px; padding: 8px;">
              <div>
                <span style="display: inline-block; width: 180px;height: 20px;">Commission Letter No :</span>
                <span>{{ data.rcpt_no }}</span>
              </div>

              <div>
                <span style="display: inline-block; width: 180px;">Commission Date :</span>
                <span>{{ data.rcpt_date | date: "dd-MM-yyyy" }}</span>
              </div>
            </td>


          </tr>
          <tr class="comm-head-2">
            <th style="padding: 4px;">Advt<br>Name</th>
            <th style="padding: 4px;">Invoice<br>No</th>
            <th style="padding: 4px;">Inv.<br>Date</th>
            <th style="padding: 4px;">Issue<br>Name</th>
            <th style="padding: 4px;">Issue<br>Date</th>
            <th style="padding: 4px;">Net<br>Amt</th>
            <th style="padding: 4px;">Rcv<br>Amt</th>
            <th style="padding: 4px;">Comm<br>%</th>
            <th style="padding: 4px;">Comm<br>Amt</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let data of getmodaldata; let i = index">
            <td class="text-left"
              style="white-space: nowrap; padding: 3px; overflow: hidden; text-overflow: ellipsis; max-width: 120px;">
              {{ data.advt_name}}
            </td>
            <td class="text-left" style="white-space: nowrap; padding: 3px;font-size: 13px;">{{ data.advt_invoice_no }}
            </td>
            <td style="white-space: nowrap; padding: 3px;font-size: 13px;text-align: center;">{{ data.advt_invoice_date
              }}</td>
            <td class="text-left" style="white-space: nowrap; padding: 3px;text-align: center;font-size: 13px;">{{
              data.DS_ISSUENAME }}</td>
            <td style="white-space: nowrap; padding: 3px;text-align: center;font-size: 13px;">{{ data.DS_ISSUEDATE }}
            </td>
            <td style="white-space: nowrap; text-align: right; padding: 3px;font-size: 13px;">{{ data.net_amount}}</td>
            <td class="text-end" style="white-space: nowrap; text-align: right; padding: 3px;font-size: 13px;">{{
              data.rcv_amt}}</td>
            <td class="text-end" style="white-space: nowrap; text-align: right; padding: 3px;font-size: 13px;">
              {{data.commissionPercentage }}</td>
            <td class="text-end" style="white-space: nowrap; text-align: right; padding: 3px;font-size: 13px;">{{
             (data.commissionAmount * 1).toFixed(2)}}</td>
          </tr>
        </tbody>
        <tfoot>
          <!-- Row for individual column totals -->
          <tr style="background-color: #f0f0f0; font-weight: bold;">
            <td colspan="5" style="text-align: right; padding: 4px; font-weight: bold;">Totals:</td>
            <td class="text-end" style="text-align: right; padding: 4px; font-weight: bold;">
              {{ totalNetAmount()}}
            </td>
            <td class="text-end" style="text-align: right; padding: 4px; font-weight: bold;">
              {{ totalRcvAmount()}}
            </td>
            <td colspan="1" style="padding: 4px;"></td>
            <td class="text-end" style="text-align: right; padding: 4px; font-weight: bold;">
              {{ (balamount * 1).toFixed(2)}}
            </td>
          </tr>

          <!-- Total Commission row -->
          <tr>
            <td colspan="5" style="text-align: right; padding: 4px;">Total Commission:</td>
            <td colspan="4" style="text-align: right;font-weight: bold; padding: 4px;">
              {{ getFormattedCommissionAmount() }}
            </td>
          </tr>


          <tr>
            <td colspan="5" style="text-align: right; padding: 4px;">Paid Commission:</td>
            <td colspan="4" style="text-align: right;font-weight: bold; padding: 4px;font-size: 13px;">
              {{ (data.crdtvamt * 1).toFixed(2)}}
            </td>
          </tr>

          <tr>
            <td colspan="5" style="text-align: right; padding: 4px;">Balance Commission:</td>
            <td colspan="4" style="text-align: right; font-weight: bold; padding: 4px;">
              {{ getBalanceCommission() }}
            </td>
          </tr>

          <!-- TDS Percentage row -->
          <tr>
            <td colspan="5" style="text-align: right; padding: 4px; font-weight: bold;">TDS: {{ tdspercentage }}% - TDS
              Amount: </td>

            <td colspan="4" style="text-align: right; padding: 4px;font-weight: bold;"> {{ getFormattedTDSAmount() }}
            </td>

          </tr>

          <tr>
            <!-- Label -->
            <td colspan="4" style="text-align: right; padding: 4px; font-weight: bold;">
              Roundoff:
            </td>



            <!-- Roundoff Remark -->
            <td colspan="3" style="padding: 4px;">
              <textarea formControlName="round_off_remark" placeholder="Roundoff remark" rows="1" style="
        width: 100%;
        resize: none;
        font-size: 12px;
        padding: 3px;
        box-sizing: border-box;
      ">
    </textarea>
            </td>


            <!-- Roundoff Amount -->
            <td colspan="2" style="padding: 4px; text-align: right;">
              <input type="number" formControlName="round_off_amount" placeholder="0.00" style="
        width: 100%;
        text-align: right;
        font-weight: bold;
        font-size: 12px;
        padding: 3px;
        box-sizing: border-box;
      ">
            </td>


          </tr>



          <!-- Net Payable Amount row -->
          <tr style="background-color: #e8f5e8;">
            <td colspan="5" style="text-align: right; padding: 4px; font-weight: bold;">Net Payable Amount:</td>
            <td colspan="4" style="text-align: right;font-weight: bold; padding: 4px; font-size: 14px;">
              {{ getNetPayableAmount() }}
            </td>
          </tr>

          <!-- Paid Commission Details header -->
          <tr>
            <td colspan="9"
              style="text-align: center; font-size: 14px; padding: 12px; font-weight: bold;background-color: cornflowerblue;">
              Paid
              Commission Details</td>
          </tr>

          <!-- Bank and Payment Details -->
          <tr>
            <td style="padding: 2px;">
              <label style="font-size: 12px;font-weight: bold;">Ac Name</label>
              <input type="text" formControlName="bank_Acname" placeholder="Ac Name"
                style="width: 90%; font-size: 9px; padding: 1px;">
            </td>
            <td style="padding: 2px;">
              <label style="font-size: 12px;font-weight: bold;">Ac No</label>
              <input type="text" formControlName="bank_no" placeholder="Ac No"
                style="width: 90%; font-size: 12px; padding: 1px;">
            </td>
            <td style="padding: 2px;">
              <label style="font-size: 12px;font-weight: bold;">Bank</label>
              <input type="text" formControlName="bank_bname" placeholder="Bank Name"
                style="width: 90%; font-size: 9px; padding: 1px;">
            </td>
            <td style="padding: 2px;">
              <label style="font-size: 12px;font-weight: bold;">IFSC</label>
              <input type="text" formControlName="bank_IFSC" placeholder="IFSC"
                style="width: 90%; font-size: 9px; padding: 1px;">
            </td>
            <td style="padding: 2px;">
              <label style="font-size: 12px;font-weight: bold;">Branch</label>
              <input type="text" formControlName="bank_Branch" placeholder="Branch"
                style="width: 90%; font-size: 12px; padding: 1px;">
            </td>
            <td colspan="2" style="padding: 2px;">
              <label style="font-size: 12px;font-weight: bold;">Voucher No</label>
              <input type="text" formControlName="voucher_no" placeholder="Voucher No"
                style="width: 95%; font-size: 12px; padding: 1px;">
              <br>
              <label style="font-size: 12px;font-weight: bold;">Cheque No</label>
              <input type="text" formControlName="bank_Cheque" placeholder="Cheque No"
                style="width: 95%; font-size: 12px; padding: 1px;">
            </td>
            <td colspan="2" style="padding: 2px;">
              <!-- <label style="font-size: 12px;font-weight: bold;">Cheque Date</label>
              <input type="date" formControlName="cheque_date" placeholder="Cheque Date" 
                     style="width: 95%; font-size: 12px; padding: 1px;">
              <br> -->
              <label style="font-size: 12px;font-weight: bold;">Voucher Date</label>
              <input type="text" formControlName="voucher_date" placeholder="Voucher Date"
                style="width: 95%; font-size: 12px; padding: 1px;">
            </td>
          </tr>
        </tfoot>
      </table>
    </form>

    <div style="margin-left: 70%;  margin-bottom: 2%">
      <button class="noPrint mr-2" mat-raised-button color="primary" (click)="savecomdetails()">Save</button>
      <button class="modern-btn btn-primary-modern noPrint" (click)="exportExcel('Commission_Report')" mat-raised-button
        color="primary">
        Export
      </button>
      <button class="noPrint" style="margin-right: 2%; margin-left: 2%" mat-raised-button color="primary"
        printSectionId="print-section1" ngxPrint [useExistingCss]="true">
        Print
      </button>
      <button class="noPrint mr-2" mat-raised-button color="primary" (click)="closeexp()">Close</button>
    </div>
  </div>
</div>